import { render } from "./AggregateTrucks.vue?vue&type=template&id=491a27d0"
import script from "./AggregateTrucks.vue?vue&type=script&lang=js"
export * from "./AggregateTrucks.vue?vue&type=script&lang=js"

import "./AggregateTrucks.vue?vue&type=style&index=0&id=491a27d0&lang=scss"

import exportComponent from "/opt/build/repo/sleeper-trader/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__